"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.INPUT_GRID_GAP = exports.INPUT_FOOTER_HEIGHT = void 0;
const INPUT_GRID_GAP = exports.INPUT_GRID_GAP = 'S200';
const INPUT_FOOTER_HEIGHT = exports.INPUT_FOOTER_HEIGHT = 21;